@if (formGroup) {
  <div class="hflex-100 flex-align-items-center">
    <div class="split-width">
      <mdw-date-picker
        class="fill-width"
        triggerType="input"
        [filterType]="filterType()"
        [value]="formGroup.value.date"
        (valueChange)="formGroup.patchValue({ date: $event })"
      ></mdw-date-picker>
    </div>
    <div class="split-width">
      <mdw-time-picker
        class="fill-width"
        triggerType="input"
        [value]="formGroup.value.time"
        (valueChange)="formGroup.patchValue({ time: $event })"
      ></mdw-time-picker>
    </div>
  </div>
}
